import { useContext, useEffect, useState } from 'react';
import useGenericEventProcessor from '@hooks/processors/use-generic-event-processor';
import apiClient from '@utils/api-client';
import { apiInternalGenericEventsPath } from '@routes';
import { TenantContext } from '@contexts/tenant-context';
const useGetGenericEvents = (queryParams) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const { processGenericEvent } = useGenericEventProcessor();
    const { tenant } = useContext(TenantContext);
    useEffect(() => {
        var _a;
        if (!((_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.enableGenericEvents) || queryParams === null) {
            setData([]);
            setLoading(false);
            return;
        }
        const controller = new AbortController();
        setLoading(true);
        apiClient
            .get(apiInternalGenericEventsPath(), {
            params: queryParams,
            signal: controller.signal
        })
            .then((response) => {
            const result = response.data.data;
            const processedData = result.map((e) => processGenericEvent(e));
            setData(processedData);
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setData([]);
                setError(err);
            }
        })
            .finally(() => {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        });
        return () => {
            controller.abort();
        };
    }, [queryParams, tenant]);
    return { data, loading, error };
};
export default useGetGenericEvents;
